import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

function Services() {
    return (
    <>
   <Helmet>
        <title>Commercial Cleaning Services Christchurch | Office &amp; Industrial Cleaning</title>
        <meta name="description" content="Looking for commercial cleaning services in Christchurch? Clear &amp; Clean provides office cleaning, industrial cleaning, warehouse cleaning, retail and deep cleaning solutions across Canterbury." />
        <meta name="keywords" content="commercial cleaning services Christchurch, office cleaning Christchurch, industrial cleaning Canterbury, warehouse cleaning services, retail cleaning NZ" />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large" />
        <link rel="canonical" href="https://www.clearandclean.co.nz/services" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Clear &amp; Clean" />
        <meta property="og:url" content="https://www.clearandclean.co.nz/services" />
        <meta property="og:title" content="Commercial Cleaning Services Christchurch | Clear &amp; Clean" />
        <meta property="og:description" content="Expert commercial cleaning services in Christchurch including office, industrial, warehouse and retail cleaning." />
        <meta property="og:image" content="https://www.clearandclean.co.nz/images/service_2.jpg" />
        <meta property="og:image:alt" content="Commercial cleaning services Christchurch" />
        <meta property="og:locale" content="en_NZ" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Commercial Cleaning Services Christchurch | Clear &amp; Clean" />
        <meta name="twitter:description" content="Professional commercial cleaning services in Christchurch — office, industrial, warehouse and retail." />
        <meta name="twitter:image" content="https://www.clearandclean.co.nz/images/service_2.jpg" />

        {/* Structured Data — Service */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Commercial Cleaning",
            "name": "Commercial Cleaning Services Christchurch",
            "url": "https://www.clearandclean.co.nz/services",
            "description": "Professional commercial cleaning services in Christchurch including office, industrial, warehouse and retail cleaning.",
            "provider": {
              "@type": "LocalBusiness",
              "name": "Clear & Clean",
              "url": "https://www.clearandclean.co.nz",
              "telephone": "+64220866040",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "23 Conailles Street",
                "addressLocality": "Halswell",
                "addressRegion": "Canterbury",
                "postalCode": "8025",
                "addressCountry": "NZ"
              }
            },
            "areaServed": {
              "@type": "City",
              "name": "Christchurch"
            },
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Cleaning Services",
              "itemListElement": [
                {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Office & Workplace Cleaning"}},
                {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Retail & Showroom Cleaning"}},
                {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Industrial & Warehouse Cleaning"}},
                {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Medical & Healthcare Cleaning"}},
                {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Education & School Cleaning"}},
                {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Common Area & Facility Cleaning"}}
              ]
            }
          }
        `}</script>

        {/* BreadcrumbList */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home",     "item": "https://www.clearandclean.co.nz/" },
              { "@type": "ListItem", "position": 2, "name": "Services", "item": "https://www.clearandclean.co.nz/services" }
            ]
          }
        `}</script>

        {/* FAQPage — helps win featured snippets */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What commercial cleaning services does Clear & Clean offer in Christchurch?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Clear & Clean offers office and workplace cleaning, retail and showroom cleaning, industrial and warehouse cleaning, medical and healthcare cleaning, school and education cleaning, and common area and facility cleaning across Christchurch and Canterbury."
                }
              },
              {
                "@type": "Question",
                "name": "How often should I schedule commercial cleaning for my office?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Most offices benefit from daily or nightly cleaning. However, the ideal frequency depends on foot traffic, industry requirements, and hygiene standards. Clear & Clean can tailor a cleaning schedule to suit your needs."
                }
              },
              {
                "@type": "Question",
                "name": "Is Clear & Clean insured?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, Clear & Clean is fully insured. Our team is professionally trained and our services meet all relevant New Zealand health and safety requirements."
                }
              },
              {
                "@type": "Question",
                "name": "Do you offer after-hours or weekend commercial cleaning in Christchurch?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, Clear & Clean offers flexible scheduling including after-hours and weekend cleaning services to minimise disruption to your business operations."
                }
              },
              {
                "@type": "Question",
                "name": "How do I get a quote for commercial cleaning?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "You can request a free quote by visiting our Contact page at clearandclean.co.nz/contact, calling +64 22 086 6040, or emailing info@clearandclean.co.nz."
                }
              }
            ]
          }
        `}</script>
      </Helmet>
         <section className="hero-wrap hero-wrap-2" style={{backgroundImage: 'url("images/service_2.jpg")'}} data-stellar-background-ratio="0.5">
        <div className="overlay" />
        <div className="container">
          <div className="row no-gutters slider-text align-items-end">
            <div className="col-md-9 ftco-animate pb-5">
              <p className="breadcrumbs mb-2"><span className="mr-2">
               <Link to="/">
                Home <i className="fa fa-chevron-right" />
              </Link>
                
                </span> <span>Services <i className="fa fa-chevron-right" /></span></p>
              <h1 className="mb-0 bread">Services</h1>
            </div>
          </div>
        </div>
      </section>
      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-center pb-5 mb-3">
            <div className="col-md-7 heading-section text-center ftco-animate">
              <span className="subheading">Services</span>
              <h2>Commercial Cleaning Services</h2>
            </div>
          </div>
          <div className="row mb-6">
            <div className="col-md-4 col-lg-4 ftco-animate d-flex fadeInUp ftco-animated">
              <div className="staff">
                <div className="img-wrap d-flex align-items-stretch">
                  <div className="img align-self-stretch" style={{backgroundImage: 'url(images/service_1.jpg)'}} />
                </div>
                <div className="text pt-3 px-3 pb-4">
                  <h3 className="heading">Office &amp; Workplace Cleaning</h3>
                  <p>Comprehensive daily or scheduled cleaning
                    including workstations, kitchens, washrooms, meeting rooms, flooring, and
                    high-touch surfaces. Designed to maintain professional presentation and
                    hygiene compliance.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg-4 ftco-animate d-flex fadeInUp ftco-animated">
              <div className="staff">
                <div className="img-wrap d-flex align-items-stretch">
                  <div className="img align-self-stretch" style={{backgroundImage: 'url(images/service_2.jpg)'}} />
                </div>
                <div className="text pt-3 px-3 pb-4">
                  <h3 className="heading">Retail &amp; Showroom Cleaning</h3>
                  <p>Cleaning services tailored for customer-facing
                    environments where presentation and first impressions are critical.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg-4 ftco-animate d-flex fadeInUp ftco-animated">
              <div className="staff">
                <div className="img-wrap d-flex align-items-stretch">
                  <div className="img align-self-stretch" style={{backgroundImage: 'url(images/service_3.jpg)'}} />
                </div>
                <div className="text pt-3 px-3 pb-4">
                  <h3 className="heading">Industrial &amp; Warehouse Cleaning</h3>
                  <p>Comprehensive daily or scheduled cleaning
                    including workstations, kitchens, washrooms, meeting rooms, flooring, and
                    high-touch surfaces. Designed to maintain professional presentation and
                    hygiene compliance.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 col-lg-4 ftco-animate d-flex fadeInUp ftco-animated">
              <div className="staff">
                <div className="img-wrap d-flex align-items-stretch">
                  <div className="img align-self-stretch" style={{backgroundImage: 'url(images/service_4.jpg)'}} />
                </div>
                <div className="text pt-3 px-3 pb-4">
                  <h3 className="heading">Medical &amp; Healthcare Cleaning</h3>
                  <p>High-level sanitation and infection control
                    procedures following strict hygiene standards.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg-4 ftco-animate d-flex fadeInUp ftco-animated">
              <div className="staff">
                <div className="img-wrap d-flex align-items-stretch">
                  <div className="img align-self-stretch" style={{backgroundImage: 'url(images/service_5.jpg)'}} />
                </div>
                <div className="text pt-3 px-3 pb-4">
                  <h3 className="heading">Education &amp; School Cleaning</h3>
                  <p>Safe, child-conscious cleaning systems
                    ensuring hygienic learning environments with compliant processes.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg-4 ftco-animate d-flex fadeInUp ftco-animated">
              <div className="staff">
                <div className="img-wrap d-flex align-items-stretch">
                  <div className="img align-self-stretch" style={{backgroundImage: 'url(images/service_6.jpg)'}} />
                </div>
                <div className="text pt-3 px-3 pb-4">
                  <h3 className="heading"> Common Area &amp; Facility Cleaning</h3>
                  <p>Cleaning for shared building spaces
                    including lobbies, corridors, lifts, stairwells, and amenities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

          <div className="row justify-content-center mt-5">
            <div className="col-md-7 text-center">
              <p className="mb-3" style={{ color: "#666" }}>
                Looking for more specialist cleaning services? Browse our full range.
              </p>
              <Link
                to="/all-services"
                className="btn btn-primary px-4 py-2"
              >
                View All Cleaning Services <i className="fa fa-arrow-right ml-2" />
              </Link>
            </div>
          </div>

      </section>
      </>
    );
  }


export default Services;